const PERMISSION_KEY= "prices:config_system";
const PAGE_URL = {
    CONFIG_SYSTEM_PAGE: "/admin/prices/config-system"
}

export {PERMISSION_KEY, PAGE_URL}

